/* import __COLOCATED_TEMPLATE__ from './evalboard.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface EvalBoard {
  modelNumber: string;
  quantity: number;
}
///////////////////////////////////////////////////////////////////////////////
// dialog-evalboard - component for the order evaluation board dialog        //
///////////////////////////////////////////////////////////////////////////////

interface EvalboardDialogArgs {
  order: () => void;
  close: (type: string) => void;
  title: string;
  message: string;
  model: EvalboardData[];
  evalBoardMultiple: boolean;
  shoppingCartEvalBoardUrl: string;
}

type EvalboardData = {
  evalBoardModelNumber: string;
  partsOnEvalBoard: string[];
  stage: string;
  stageChannel: string;
  stageImplementation: string;
  stageType: string;
};

export default class EvalboardDialog extends Component<EvalboardDialogArgs> {
  ////////////////////////////////////////////////////////////////////////////////
  // Properties                                                                 //
  ////////////////////////////////////////////////////////////////////////////////
  get url(): string {
    const result = this.args.shoppingCartEvalBoardUrl.replace('{partlist}', this.evalBoardShoppingUrl.parts);
    console.log('URL for Eval Board shopping: ', result);
    return result;
  }
  get evalBoardDisplay(): {
    stage: string;
    stageType: string;
    stageImplementation: string;
    stageChannel: string;
    evalBoardModelNumber: string;
    partsOnEvalBoard: string[];
    hasStageInfo: boolean;
  }[] {
    const result = [];
    for (let i = 0; i < this.args.model.length; i++) {
      const item = this.args.model[i];
      if (item) {
        result.push({
          stage: item.stage,
          stageType: item.stageType,
          stageImplementation: item.stageImplementation,
          stageChannel: item.stageChannel,
          evalBoardModelNumber: item.evalBoardModelNumber,
          partsOnEvalBoard: item.partsOnEvalBoard,
          hasStageInfo:
            item.stageType !== 'none' || item.stageImplementation !== 'none' || item.stageChannel !== 'none',
        });
      }
    }
    return result;
  }

  get evalBoardShoppingUrl(): { parts: string } {
    const evalBoardData = this.args.model.map((x) => x);
    const evalBoardOrder: EvalBoard[] = [];
    // Weed any unavailable boards out of order before sending to shopping cart
    const reducedData = evalBoardData.filter((data) => {
      return data.evalBoardModelNumber !== null;
    });

    for (const [index, data] of reducedData.entries()) {
      const evalBoard: EvalBoard = {
        modelNumber: data.evalBoardModelNumber,
        quantity: 1,
      };
      if (index === 0) {
        // if there is more than 4 stages, we need more than one motherboard
        // each motherboard can hold up to 4 daughterboards.
        if (evalBoardData.length > 4 && evalBoardData.length % 4 > 0) {
          // set Evalboard Data for motherboard with more than 4 stages
          evalBoardOrder.push(this.setMotherboard(evalBoard));
        } else {
          evalBoardOrder.push(evalBoard);
        }
      } else {
        // only order one 4-pack of daughterboard per up to 4 stages (same board)
        // daughterboards come in 4-packs. If there is more than one same daugherboard and up to 4, only order one pack.
        if (data.evalBoardModelNumber.indexOf('*') === -1) {
          evalBoardOrder.push(evalBoard);
        }
      }
    }

    const partlist = this.setParts(evalBoardOrder);
    return { parts: partlist };
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Functions                                                                  //
  ////////////////////////////////////////////////////////////////////////////////
  setMotherboard(evalBoardOrder: EvalBoard): EvalBoard {
    const evalBoard = evalBoardOrder.modelNumber.split(' ');
    if (evalBoard.length > 2) {
      evalBoardOrder.modelNumber = evalBoard[2] ?? evalBoardOrder.modelNumber;
      evalBoardOrder.quantity = evalBoard[0] ? parseInt(evalBoard[0]) : evalBoardOrder.quantity;
    }
    return evalBoardOrder;
  }

  setParts(evalBoardOrder: EvalBoard[]): string {
    let partlist = '';
    const evalBoard = evalBoardOrder.reduce((accumulator: Record<string, number>, value: EvalBoard) => {
      return { ...accumulator, [value.modelNumber]: (accumulator[value.modelNumber] || 0) + value.quantity };
    }, {});

    Object.keys(evalBoard).forEach((key) => {
      partlist = partlist + `${key},${evalBoard[key]}|`;
    });

    return partlist.substring(0, partlist.length - 1).replaceAll(' ', '%20');
  }
  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////
  @action processEvalBoard(closeDialog: () => void): void {
    if (this.args.order) {
      this.args.order();
    }
    // If the customer needs to refer back to this page when filling the order form on the supplied page,
    // we may choose not to close the dialog so the customer doesn't have to reopen it.
    if (closeDialog) {
      closeDialog();
    }
  }
}
